import { BaseService } from "./BaseService";

export class TestService extends BaseService {
  test() {
  }
}
